import Vue from 'vue'
import axios from 'axios'

Vue.mixin({
    methods: {
 
        /**
         * INIT
         */
        ssoInit()
        {            
            //get visitor ID
            this.ssoVisitorId(vid=>{ if(vid) { this.$store.state.data.visitorId = vid } })

            //get GA ID
            this.ssoGAId(gaId=>{ window.kly.visitor.gaid = gaId; })

            const queryString = window.location.search;

            if( queryString )
            {
                const urlParams = new URLSearchParams(queryString);

                var ssouId = urlParams.get('sso-uid');

                if(ssouId )
                {
                    ssouId = ssouId.replace(/\/$/, "");
                }

                return ssouId;
            }
        },

        /**
         * LOGIN
         */
        ssoLogin(callback)
        {
            //existing
            if( this.$store.state.data?.userLogin )
            {
                return callback(this.$store.state.data.userLogin); 
            }

            var uid = this.ssoUserId()
            
            this.ssoCheck(res=>{

                var th = this

                //show Error
                if( res.error )
                {
                    this.$toasted.show(res.error, {type:'error'}).goAway(1500);
                }

                res.data.id = res.data.id || uid;

                if( res.data.id )
                {
                    //get detail user
                    this.ssoUser(res.data.id, user=>{

                        this.$store.state.data.userLogin = user;
                        //console.log("debug3: ",user);
                        //check unique
                        if( this.$store.state.data?.get?.is_unique && this.$store.state.data?.get?.using_sso && user?.data?.id )
                        {
                            
                            this.$store.dispatch('api_post_ic_last_answered', {
                                user_id: user.data.id,
                                callback: function(res){
                                    if(res?.data?.status == 'success')
                                    {
                                        th.$store.state.afterLoginPage = 'result';
                                        th.$store.state.afterLoginPageParams = {'submitted': 1};
                                        return callback(user);
                                    }
                                }
                            })
                        }

                        //next
                        return callback(user);
                    })                    
                }
                else
                {
                    var _referrer = document.referrer ? document.referrer : window.location.href;
                    parent.postMessage(JSON.stringify({
                        'event': 'newshub_ic2_resize',
                        'height': 800,
                        'id': this.$store.state.data.get.id,
                    }), _referrer);

                    //console.log('res', this.ssoAuthLink())
                    
                    window.location.href = this.ssoAuthLink()
                }
                
            })
        },

        /**
         * GET USER ID FROM COOKIE
         */
        ssoUserId()
        {
            if( this.$store.state.sso_config.uid )
            {
                return this.$store.state.sso_config.uid
            }

            var cName ='liputan6_id_u_id=',
            cUserId = document.cookie.split(';').find(v=>{ return v.match(cName);});

            if( !cUserId )
            {
                const queryString = window.location.search;

                if( queryString )
                {
                    const urlParams = new URLSearchParams(queryString);

                    cUserId = urlParams.get('sso-uid');
                }
            }
            
            return cUserId ? decodeURIComponent(cUserId).trim().replace(cName,'').replace(/\/$/, "") : '';
        },

        /**
         * GET USER DETAIL
         */
        ssoUser(userId, callback)
        {
            //this.ssoReq("/api/user/get/" + encodeURIComponent(userId), res=>{
            this.ssoReq("/api/user/get/" + (userId), res=>{
            
                if( res.status )
                {
                    if(res.data.data)
                    {
                        res.data = res.data.data
                        res.data.id = userId
                    }
                }
    
                return callback(res);
            });
        },

        /**
         * GET VISITOR ID FROM VIDEO
         */
        ssoVisitorId(callback)
        {
            var c = 0;

            var cVstId = setInterval(function(){

                if (typeof(window.ahoy) !== "undefined" && c<10)
                {
                    if (typeof(window.ahoy.visitorId) === "undefined" )
                    {
                        window.ahoy.visitorId = decodeURIComponent(document.cookie.split(';').find(v=>{ return v.match('ahoy_visitor=');})).trim().replace('ahoy_visitor=', '');
                    }
                    
                    if (typeof(window.ahoy.visitorId) !== "undefined" )
                    {
                        clearInterval(cVstId)
                    
                        return callback(window.ahoy.visitorId)
                    }
                    
                    /*window.VidioPersonalization.getVisitorId(visitorId => {

                        clearInterval(cVstId)

                        return callback(visitorId)

                    });*/
                }

                c++;

            }, 1000);
        },

        /**
         * GET GA ID FROM GOOGLE ANALYTIC
         */
        ssoGAId(callback)
        {
            var c = 0;

            var cGaId = setInterval(function(){

            if (typeof window.ga === 'function' && c<10)
            {
                if((window?.ga || null) && (typeof window.ga.getAll === 'function') )
                {
                    var gid = window?.ga.getAll()[0].get('clientId');

                    if( gid )
                    {
                        clearInterval(cGaId)

                        return callback(gid)
                    }
                }
            }

            c++;

            }, 1000);
        },

        /**
         * AXIOS
         */
        ssoAx()
        {
            return axios.create({
                baseURL: this.$store.state.sso_config.endPoint,
                headers: {
                    "client-id": this.$store.state.sso_config.clientId,
                    "client-secret": this.$store.state.sso_config.clientSecret,
                }
            });
        },

        /**
         * REQUEST
         */
        ssoReq(url, callback)
        {
            var result = {
                status: false,
                error: null,
                data: null
            };
            
            this.ssoAx().get(url)
                .then( res => {

                    result.status = true;
                    result.data = res.data;

                    return callback(result);
                })
                .catch(error => {
                    
                    result.error = (error ? error.toJSON().message : null) || null

                    return callback(result);
                })
        },
        
        /**
         * GET LINK LOGIN
         */
        ssoAuthLink(next)
        {
            
            var q ={};location.search.replace(/([^?&=]+)=([^&]+)/g,(_,k,v)=>q[k]=v);q;

            next = next ? next : this.$store.state.iframe_url;
            
            if( q.refferer ) next = decodeURIComponent(q.refferer)

            //console.log('next');
            //console.log(next);
            
            return  this.$store.state.sso_config.endPoint + '/login/application?client_id='+ 
                    this.$store.state.sso_config.clientId +'&client_secret=' +
                    this.$store.state.sso_config.clientSecret +'&thirdparty=0&redirect=' + encodeURIComponent(next)
        },

        /**
         * CHECK STATUS LOGIN
         */
        ssoCheck(callback)
        {
            //get user ID
            var uid = this.ssoUserId();

            //get Visitor ID
            this.ssoVisitorId(vid=>{
                
                //request API
                //this.ssoReq("/login/application/status?visitor_id=" + vid + "&uid=" + uid, res=>{
                this.ssoReq("/login/application/status?uid=" + uid, res=>{

                    if( res.data ) 
                    {
                        res.data.visitorId = vid;
                        res.data.id = vid;
                    }

                    if( res.status )
                    {
                        return callback(res.data);    
                    }
                    else return callback(res);
                });
            })
        },

        /**
         * SEND DATA TO SSO
         */
        ssoSend(types)
        {
            var dataSSO = this.profilingFormatted(types);

            if( dataSSO )
            {
                //send to SSO data
                var userId = this.$store.state.data?.userLogin ? this.$store.state.data?.userLogin?.data?.id : null;
                
                if( userId )
                {
                    this.ssoAx().post("/api/user/set/"+userId, dataSSO)
                        .then( () => {
                            //console.log(res)
                        })
                }
            }
        },

        /**
         * SEND DATA TO SSO
         */
        ssoSendAdditional()
        {
            var dataOut = {
                uuid: this.$store.state.data?.get?.id || '-',
                additional: this.$store.state.data.post.additional
            };

            if( dataOut && dataOut.additional )
            {
                //send to SSO data
                var userId = this.$store.state.data?.userLogin ? this.$store.state.data?.userLogin?.data?.id : null;
                
                if( userId )
                {
                    this.ssoAx().post("/api/user/set/"+userId, dataOut)
                        .then( () => {
                            //console.log(res)
                        })
                }
            }
        },

        profilingFormatted(types)
        {
            var forms = this.$store.state.data.get.profiling ? this.$store.state.data.get.profiling.form : null;
            var profiling = this.$store.state.data.post.profiling_answer;
            var dataOut = {
                    uuid: this.$store.state.data.get.id || '-'
                };
                dataOut.additional = {
                    "ic_id": this.$store.state.data.get.id || '-'
                }

            if( forms )
            {
                for( var f in forms )
                {
                    for( var t in types )
                    {
                        var type = types[t]

                        if( forms[f].validasi && forms[f].validasi.includes(type))
                        {
                            if( type=='age'  )
                            {
                                dataOut['birthday'] = new Date().getFullYear() - parseInt(profiling[forms[f].input_name]) + '-01-01';
                            }
                            else if( type=='yob'  )
                            {
                                dataOut['birthday'] = parseInt(profiling[forms[f].input_name]) + '-01-01';
                            }
                            else if( type=='dob'  )
                            {
                                dataOut['birthday'] = profiling[forms[f].input_name];
                            }
                            else dataOut[type] = profiling[forms[f].input_name]
                        }
                    }
                }
                //additional profiling
                if( profiling[forms[f].input_name] && !['email', 'phone', 'name', 'gender', 'birthday'].includes(this.slugify(forms[f].label)) )
                {
                    dataOut['additional'][this.slugify(forms[f].label)] = profiling[forms[f].input_name];
                }                
            }

            return dataOut
        },

        /**
         * VIEW TRACKER
         */
        viewTracker(page)
        {
            var api = this.$store.state.data.get ? this.$store.state.data.get : null;

            //set title
            this.$store.state.data.meta.title = (api ? api.name : document.title) + ' - ' + page

            this.$gtag.pageview({
                page_title: this.$store.state.data.meta.title,
                page_path: this.$route.path,
            })

            //set event pv
            const event = new CustomEvent('ic_page_view', { detail: {
                page:page,
                path:this.$route.path,
                title:this.$store.state.data.meta.title
            } });
            window.dispatchEvent(event);

            //Facebook pixel tag
            if( this.$store.state.data.get.using_tracker )
            {
                if( this.$store.state.data.get.tracker_site_id == 'facebook.com' && this.$store.state.data.get.tracker_goal_id )
                {
                    /*eslint-disable */
                    !function(f,b,e,v,n,t,s)
                    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                    n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                    if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                    n.queue=[];t=b.createElement(e);t.async=!0;
                    t.src=v;s=b.getElementsByTagName(e)[0];
                    s.parentNode.insertBefore(t,s)}(window, document,'script',
                    'https://connect.facebook.net/en_US/fbevents.js');
                    fbq('init', this.$store.state.data.get.tracker_goal_id);
                    fbq('track', 'PageView');
                    /*eslint-disable */

                    if( page == 'result' )
                    {
                        /*eslint-disable */
                        !function(f,b,e,v,n,t,s)
                        {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
                        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
                        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
                        n.queue=[];t=b.createElement(e);t.async=!0;
                        t.src=v;s=b.getElementsByTagName(e)[0];
                        s.parentNode.insertBefore(t,s)}(window, document,'script',
                        'https://connect.facebook.net/en_US/fbevents.js');
                        fbq('init', this.$store.state.data.get.tracker_goal_id);
                        fbq('track', 'Lead');
                        /*eslint-disable */
                    }
                }
            }

            /*var params = {
                'event': "virtual_page_view",
                'virtual_pageview_path': this.$route.path,
                'page_title': this.$store.state.data.meta.title,
                'virtual_pageview_title': this.$store.state.data.meta.title
            };
            
            if(window.dataLayer) window.dataLayer.push(params);

            //console.log('virtual_page_view', params);

            if( window.gtag )
            {
                window.gtag('event', 'virtual_page_view', params);

                window.gtag('config', 'UA-108534636-14', {'page_path': '/'+page});
            }

            //set GA title
            if(window.dataLayer) window.dataLayer.push({'pageTitle': this.$store.state.data.meta.title});*/
        },

        /**
         * SEND TRACKER
         */
        sendTracker()
        {
            var userId = this.$store.state.data?.userLogin ? this.$store.state.data?.userLogin?.data?.id : null;

            var valueYob = window.kly.visitor.age ? new Date().getFullYear() - window.kly.visitor.age : null

            const dataCDP = {
                action: userId ? 'login' : 'register',
                action_category: window.kly.visitor.audience,
                visitor_id : this.$store.state.data.visitorId,
                gaid : window.kly.visitor.gaid,
                action_details: {
                    campaign: window.kly.visitor.title, 
                    age : window.kly.visitor.age,
                    gender : window.kly.visitor.gender,
                    yob : valueYob
                }
            }
            
            var dataProfiling = this.profilingFormatted(['email', 'phone', 'age', 'gender']);

            const dataSSO = {
                visitor: this.$store.state.data.visitorId,
                yob: valueYob,
                age : window.kly.visitor.age || this.$cookies.get('newshub_age'),
                gender: window.kly.visitor.gender,
                email: dataProfiling['email'] || this.$cookies.get('newshub_email_ori'),
                phone: dataProfiling['phone'] || this.$cookies.get('newshub_phone_ori'),
                additional: dataProfiling['additional'] || null
            };

            if( userId ) dataSSO.user_id = userId

            //if(window.VidioPersonalization) window.VidioPersonalization.sendData(userId, dataCDP)
            if(window.AhoyEvent &&  (window?.ahoy?.track || null) && window.kly.visitor) window.AhoyEvent.sendPersonalizationUserEvent(dataCDP);

            if(window.SSOVISITOR && window.kly.visitor) window.SSOVISITOR.sendDataVisitor(dataSSO);
        },

        /**
         * SEND TO CDP Persistence
         */
         sendtoCDP()
         {
            //var userId = this.$store.state.data.userLogin ? this.$store.state.data.userLogin.data.id : null;
            /*if(window.VidioPersonalization)
            {
                console.log('CDP Persistence', window.kly.visitor);
                window.VidioPersonalization.sendData(userId, window.kly.visitor)
            } */
            if(window.AhoyEvent && window.ahoy?.visitorId)
            {
                window.AhoyEvent.sendPersonalizationUserEvent(window.kly.visitor);
            } 
         },

         /**
         * Send to tracker
         */
         sendExternalTracker()
         {
             /*eslint-disable */
            if( this.$store.state.data.get.using_tracker )
            {
                /*if( this.$store.state.data.get.tracker_site_id == 'facebook.com' && this.$store.state.data.get.tracker_goal_id )
                {
                    
                    //fbq('track', 'PageView');
                    
                }*/
            }
            /*eslint-disable */
         },

        /**
         * SEND TO VIDIO
         */
        sendtoVidio()
        {
            if( this.$store.state.data.get.tracker_site_id == 'vidio' && this.$store.state.data.get.tracker_goal_id)
            {
                var dataSSO = this.profilingFormatted(['email', 'age', 'yob', 'dob', 'gender']);
                var data = {
                    email: dataSSO['email'] || null,
                    gender: dataSSO['gender'] || null,
                    year_of_birth: dataSSO['birthday'] ? new Date(dataSSO['birthday']).getFullYear() : null,
                    visitor_id: this.$store.state.data.visitorId
                };

                var encodedData = btoa(JSON.stringify(data));

                var vidioUrl = 'https://www.vidio.com/watch/'+this.$store.state.data.get.tracker_goal_id;
                    vidioUrl+= this.$store.state.data.get.tracker_goal_id.indexOf("?")>0 ? '&' : '?';
                    vidioUrl+= 'ved='+encodedData;

                //window.location.href = vidioUrl

                var link=document.createElement("a");
                link.id = 'vidioPlayUrl';
                link.href= vidioUrl;
                link.target= '_blank';

                link.click();
            }
        }


    }
})